import React from "react";
import { getPrimaryImage, getPrimaryVariant } from "../../utils/product";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import saveForLater from "../../utils/saveForLater";
import { useProduct } from "../../context/product/ProductContext";
import { useVariant } from "../../context/variant/VariantContext";
import { useLooksProducts } from "../../context/looks/LooksProductsContext";
import { fireSaveForLaterMarketing } from "../../utils/marketingTracking/marketingTrackingEvents";
import {
  PAGE_AREAS,
  LOOKS_RECOMMENDATIONS_HEADER,
  SMALL_VIEWPORT,
} from "../../constants";
import {
  fireLooksAddToBagAnalytics,
  fireLooksAddToBagMarketing,
} from "../../analytics/addToBag";
import fireNotifyMeClickAnalytics from "../../analytics/backInStock";
import ProductCard from "../productCard/ProductCard";
import { PrimaryPrice } from "../priceComponents";
import { COMPLEMENTARY_PRIMARY_PRICE } from "../priceComponents/priceTypes";
import styles from "./LooksProduct.scss";
import { useViewport } from "../../context/viewport/ViewportContext";

const productLink = ({ looksProducts, product, isMobile }) => {
  const indexInCarousel = looksProducts.findIndex(
    ({ id }) => id === product.id
  );
  const btlType = isMobile ? "pop+up" : "content";

  return `${product.pdpUrl}#ctaRef-btl+${btlType}+-+btl+carousel_${
    indexInCarousel + 1
  }&featureref1-btl+${btlType}+btl+carousel`;
};

export default function LooksProduct(props) {
  const { product } = useProduct();
  const { selectedVariant } = useVariant();
  const { looksProducts } = useLooksProducts();
  const { viewportCategory } = useViewport();
  const { isMobile } = useRuntimeConstants();

  if (!product) {
    return null;
  }

  const defaultColourWayId = getPrimaryVariant(product.variants).colourWayId;
  const variantIdentifier = selectedVariant
    ? `variantId:${selectedVariant.variantId}`
    : `colourWayId:${defaultColourWayId}`;

  const handleSaveClick = (event) => {
    event.stopPropagation();
    event.preventDefault();

    const identifier = selectedVariant
      ? { variantId: selectedVariant.variantId }
      : { colourWayId: defaultColourWayId };

    const variantsAdded = selectedVariant
      ? [selectedVariant]
      : [getPrimaryVariant(product.variants)];

    saveForLater({
      product,
      items: [{ productId: product.id, ...identifier }],
      pageArea: PAGE_AREAS.LOOKS,
      looksProducts,
    });

    fireSaveForLaterMarketing({
      product,
      variantsAdded,
      component_name: "pdp_btl",
    });
  };

  const enhanceNotifyMeClickAnalytics = (selectedVariantId) => {
    fireNotifyMeClickAnalytics(
      selectedVariantId,
      PAGE_AREAS.LOOKS,
      looksProducts
    );
  };

  const handleAddToBag = async ({ selectedVariant }) => {
    await fireLooksAddToBagAnalytics(looksProducts)({ selectedVariant });
    await fireLooksAddToBagMarketing()({ selectedVariant, product });
  };

  return (
    <div className={styles.container}>
      <ProductCard
        {...{
          ...props,
          product,
          handleSaveClick,
          productLink: productLink({ looksProducts, product, isMobile }),
          variantIdentifier,
          variantSelectorId: "looksVariantSelector",
          excludedFromSizeGuideExperiment: true,
          scope: LOOKS_RECOMMENDATIONS_HEADER,
          fireAddToBagAnalytics: handleAddToBag,
          fireNotifyMeClickAnalytics: enhanceNotifyMeClickAnalytics,
          imageWidth: viewportCategory === SMALL_VIEWPORT ? 163 : 218,
          primaryImageUrl: getPrimaryImage(product.images).url,
          priceRenderProp: () => (
            <PrimaryPrice
              priceData={product.price}
              testId="product-price"
              priceType={COMPLEMENTARY_PRIMARY_PRICE}
            />
          ),
        }}
      />
    </div>
  );
}
